module.exports = __webpack_public_path__ + "static/media/picto-burger-menu.0a24c6f5.svg";